<template>
  <div v-if="!$apollo.queries.getBusinessEntityDetails.loading">
    <div>
      <FlowHeading
        title="What’s your PAYE preference?"
        sub-title="On payroll contracts (PAYE) you will be taxed as an Employee with Worksome handling the taxes. This means we'll be responsible for deductions of e.g. National Insurance Contributions from your pay."
      />
    </div>
    <div class="tw-mb-4">
      <WdsText>
        <span class="tw-font-bold">
          Are you prepared to be taxed as an Employee with Worksome handling the taxes?
        </span>
      </WdsText>
    </div>
    <div>
      <WdsCheckbox v-model:checked="canPaye" :value="canPaye">
        <WdsText
          text="Yes, I will work with PAYE on some contracts"
          sub-text="You will need to provide additional data when you enter a contract."
        />
        <WdsButtonGhost secondary @click="openLearnMoreLink">Learn more</WdsButtonGhost>
      </WdsCheckbox>
    </div>
    <div class="wds-input-group continue-button">
      <WdsButton full-width lg primary :disabled="!canSubmit" @click="callNextScreen">
        <div class="tw-flex">
          <transition name="fade">
            <ButtonSpinner v-if="isSubmitting" size="sm" color="blue" />
          </transition>
          {{ $t('Continue') }}
        </div>
      </WdsButton>
    </div>
  </div>
</template>

<script>
import { WdsButton, WdsButtonGhost, WdsCheckbox, WdsText } from '@worksome/wds-components'
import gql from 'graphql-tag'
import FlowHeading from '@/components/flows/FlowHeading.vue'
import ButtonSpinner from '@/components/ButtonSpinner.vue'

export default {
  name: 'UkPayePreferences',
  components: {
    ButtonSpinner,
    FlowHeading,
    WdsButton,
    WdsButtonGhost,
    WdsCheckbox,
    WdsText,
  },

  inject: ['skip', 'next'],

  data() {
    return {
      canPaye: false,
      isSubmitting: false,
      soleTraderUtr: '',
    }
  },
  computed: {
    canSubmit() {
      return !this.isSubmitting
    },
  },

  apollo: {
    getBusinessEntityDetails: {
      query: gql`
        query me {
          me {
            activeAccount {
              globalId
              ... on Freelancer {
                primaryBusinessEntity {
                  entityType
                  isPrimary
                  label
                  companyNo
                  companyName
                  taxNo
                  data
                }
              }
            }
          }
        }
      `,
      result({ data }) {
        const info = data.me.activeAccount.primaryBusinessEntity
        this.globalId = data.me.activeAccount.globalId
        if (info) {
          this.businessName = info.companyName ? info.companyName : ''
          this.businessNumber = info.companyNo ?? this.businessNumber
          this.entityType = info.entityType ?? this.entityType
          this.businessDetailsFinished = true
          this.salesTaxNumber = info.taxNo ?? this.salesTaxNumber

          this.businessData = JSON.parse(info.data)
          if (this.businessData && this.businessData.hasOwnProperty('can_paye')) {
            this.canPaye = this.businessData.can_paye === true
            this.soleTraderUtr = this.businessData.sole_trader_utr
          }
        }
      },
    },
  },
  methods: {
    openLearnMoreLink() {
      window.open(
        'https://help.worksome.dk/en/articles/5144049-using-worksome-s-paye-service',
        '_blank',
      )
    },
    async callNextScreen() {
      this.isSubmitting = true
      await this.savePayePreferences()
      this.next()
    },
    async savePayePreferences() {
      const businessData = {
        ...this.businessData,
        can_paye: this.canPaye ? true : null,
      }

      await this.$apollo.mutate({
        mutation: gql`
          mutation updatePrimaryBusinessEntity($input: UpdatePrimaryBusinessEntityInput!) {
            updatePrimaryBusinessEntity(input: $input) {
              globalId
              entityType
              isPrimary
              label
              companyNo
              companyName
              taxNo
              data
            }
          }
        `,
        variables: {
          input: {
            globalId: this.globalId, // must be accountID of current logged in user
            registered_company_name: this.businessName,
            business_entity: this.entityType,
            business_entity_data: JSON.stringify(businessData),
            vat_no: this.salesTaxNumber,
            company_no: this.businessNumber,
            soleTraderUtr: this.soleTraderUtr,
          },
        },
        context: {
          headers: {
            'X-FLOW-STEP-COMPLETED': this.$route.fullPath,
          },
        },
      })
    },
  },
}
</script>

<style scoped>
.continue-button {
  @apply tw-mb-3;
  @apply tw-mt-4;
}
</style>
